import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { api } from '../../services/api';
import ExportBookingsCSV from './ExportBookings';
import SortableTable from './SortableTable';
import { getBookingEndpoint } from './bookingTypeUtils';
import { BOOKING_TYPE_LABELS } from './bookingTypeLabels';

const AllBookingsViewer = ({ operators, bookingType }) => {
  const bookingTypeLabel = BOOKING_TYPE_LABELS[bookingType] ?? 'Cancelled';
  const [bookings, setBookings] = useState([]);
  const [sortedBookings, setSortedBookings] = useState([]); // ✅ Store sorted data
  const [loading, setLoading] = useState(false);
  const ExportButtonText = `Export All ${bookingTypeLabel} Bookings`;

  useEffect(() => {
    fetchAllBookings();
  }, [bookingType]);

  const fetchAllBookings = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");

      const endpoint = getBookingEndpoint(bookingType);

      const response = await api.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200) {
        setBookings(response.data);
        setSortedBookings(response.data); // Initialize sorted data
      } else {
        console.error("Error fetching all bookings:", response.data.errorMessage);
      }
    } catch (error) {
      console.error("Error fetching all bookings:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle sorted data from SortableTable
  const handleSortedData = useCallback((sorted) => {
    setSortedBookings(sorted);
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <ExportBookingsCSV
          operators={operators}
          bookings={sortedBookings} // Export sorted data
          bookingType={bookingType}
          buttonText={ExportButtonText}
          disabled={loading}
        />
      </div>

      {/* Use SortableTable component */}
      <SortableTable
        data={bookings}
        operators={operators}
        bookingType={bookingType}
        onDataChange={handleSortedData}
        loading={loading}
        showQuickSort={true}
        showOperatorColumn={true} // Show operator column in all bookings view
      />

      <div style={{ marginTop: '1rem', textAlign: 'center' }}>
        <span>Total records: {sortedBookings.length}</span>
      </div>
    </div>
  );
};

export default AllBookingsViewer;

  AllBookingsViewer.propTypes = {
    operators: PropTypes.array.isRequired,
    bookingType: PropTypes.string.isRequired
  };